<template>
 <div id="admin">
   <menu-admin/>
    <section class="int-form" style="margin-top: 30px;">
      <div class="container">

        <div class="card card-primary  d-print-none">
            
            <div class="card-body">
                <div class="row">
                    <div class="col-md-3">
                        <input type="date" class="form-control" name="dates" v-model="start_date" /> 
                    </div>

                    <div class="col-md-3">                        
                        <input type="date" class="form-control" name="dates" v-model="end_date" /> 
                    </div>

                    <div class="col-md-3">                        
                        <input type="text" class="form-control" name="clientName" v-model="clientName" 
                        placeholder="Nome..."/> 
                    </div>

                    <div class="col-md-2">                        
                        <button type="button" @click="changeDate()" 
                                class="btn btn-primary btn-block"                               
                                >Pesquisar</button>
                    </div>

                    <div class="col-md-1">                                       
                        <a class="btn btn-warning text-white " 
                                href="javascript:window.print();"                               
                                ><span class='fa fa-print'></span></a>
                        
                    </div>

                </div>

            </div>

        </div>

        <div class="row">
          <div class="col-12">
                <h5 style="margin-top:20px"> {{ status_descricao }}
                    <i v-if="start_date && end_date">entre {{ start_date_formated }} e {{ end_date_formated }}</i>
                </h5><br/>
            </div>
        </div>
            

    <div class="row">
        <div class="col-12">

            
            <div v-for="signature in signatures" v-bind:key="signature.profile_id" 
                  style="background-color:white;border:1px solid black;margin-bottom:10px;padding:10px;">
                  
                  <span v-if="signature.person_or_company">{{signature.company_name}}</span>
                  <span v-else>{{signature.name}}</span> 
                   - #{{ signature.profile_id }} 
                   <br/> Telefone: {{ signature.phone }} 
                   <!--<ul style="margin:0px;padding:0px;">
                    <li style="border:1px solid black;float:left;"> Assinaturas: {{ signature.assinaturas }}  </li>  
                    <li style="border:1px solid black;float:left;"> Renovações: {{ signature.renovacoes }}  </li>  
                    <li style="border:1px solid black;float:left;"> Compras: {{ signature.compras }}  </li>  
                   </ul> -->
                 
                  <hr/>

                  <table class="table table-bordered table-sm table-hover">
                    <tr>
                      <th width="100">Ordem Id</th>
                      <th width="100">Data</th>
                      <th width="100">NFe</th>
                      <th>Publicação</th>
                      <th width="100">Versão</th>
                      <!--<th width="100">Assinatura?</th>-->
                      <th width="100">Vencimento</th>
                      <th width="100">Renova</th>
                      <th width="100">Valor</th>
                    </tr>
                    <tr v-for="order in signature.orders" v-bind:key="order.id">   
                        <td> {{ order.order_id }} </td>
                        <td> {{ order.date | formatDate }} </td>
                        <td> {{ order.nfe }} </td>                                                          
                        <td> {{ order.publication_id }} - {{ order.name }} </td>    
                        <td> {{ order.version }} </td>    
                        <!--<td> {{ order.is_signature }} </td>    -->
                        <td v-if="order.is_signature">{{order.due | formatDate}}</td>
                        <td v-else>Compra</td> 
                        <td v-if="order.is_signature">{{order.times_renewed}}</td>
                        <td v-else>-</td>                         
                        <td> {{ order.value }} </td>                                                          
                    </tr>
                  </table>

            </div>
          
        </div>
      </div>

      </div>

    </section>
   <footer-admin/>
  </div>
</template>

<script>

  import menuAdmin from "../admin/common/menu-admin"
  import footerAdmin from "../admin/common/footer-admin"
  import mixins from "../../helpers/mixins"
  import reports from "../../api/reports"
  import moment from 'moment'

  export default {
    name: "Client",
    mixins: [mixins],
    data(){
      return {
        signatures: {},        
        start_date: '',
        end_date: '',
        clientName: '',
        status_type : null, 
        status_descricao: '', 
        total: 0
      }
    },
    components: { menuAdmin, footerAdmin },
    methods: { 

      getSignatures(start, end, clientName){
       
        start = moment(this.start_date).format('YYYY-MM-DD');
        end = moment(this.end_date).format('YYYY-MM-DD');
        clientName = this.clientName;

        if (clientName == ""){
          clientName = "*";
        }
      
        this.status_descricao = "Clientes";
        
        reports.get_clients(start, end, clientName).then((response)  =>  {                           
          this.signatures = response.data
          this.orders = this.signatures.orders
        }).catch(errors => { this.formErrors(errors) })
      },

      customFormatter(date) {
        return moment(date).format('DD/MM/YYYY');
      },
      changeDate(){        
        this.getSignatures()
      }
    },
    computed: {
      start_date_formated: function () {
        return moment(this.start_date).format('DD/MM/YYYY');
      },
      end_date_formated: function () {
        return moment(this.end_date).format('DD/MM/YYYY');
      }
    },
    mounted(){ 

      
      //this.start_date = new Date(moment().subtract(30, "days").format('YYYY-MM-DD'))
      //this.end_date = new Date()

      this.start_date = moment().startOf('month').format('YYYY-MM-DD');
      this.end_date   = moment().endOf('month').format('YYYY-MM-DD');
      this.clientName = '';
      this.getSignatures()
    }
  }

</script>
